/* eslint-disable */
import d from "axios";
import x from "axios-retry";
x(d, {
  retries: 1 / 0,
  retryDelay: (l) => l * 2e3,
  retryCondition: (l) => {
    var t;
    return ((t = l.response) == null ? void 0 : t.status) === 503;
  },
});
var u = (l) => {
    let t = l.response || {};
    throw t.data && t.data.error
      ? new Error(l.response.data.error)
      : l instanceof Error
      ? l
      : typeof l == "string"
      ? new Error(l)
      : new Error("Unknown error");
  },
  p = class {
    constructor() {
      this.projectId = 46;
      this.isServer = !(typeof window < "u" && window.document);
      this.url = "https://us-central1-anvil-6fe83.cloudfunctions.net";
    }
    setApiKey(t) {
      d.defaults.headers.common.Authorization = `JWT ${t}`;
    }
    getInventory(t, e = !1) {
      return d
        .post(`${this.url}/getInventory`, { utxos: t, testEnv: e })
        .then((r) => r.data)
        .catch((r) => u(r));
    }
    claimCribs(t, e, r, n, s, i = !1) {
      if (!this.isServer)
        throw new Error("This function must be used server-side only");
      return d
        .post(`${this.url}/claimCribs`, {
          utxos: t,
          changeAddress: e,
          unit: r,
          assetName: n,
          wallet: s,
          testEnv: i,
        })
        .then((a) => a.data)
        .catch((a) => u(a));
    }
    mintLand(t, e, r, n, s = !1) {
      if (!this.isServer)
        throw new Error("This function must be used server-side only");
      return d
        .post(`${this.url}/mintMonster`, {
          utxos: t,
          changeAddress: e,
          assetName: r,
          wallet: n,
          testEnv: s,
        })
        .then((i) => i.data)
        .catch((i) => u(i));
    }
    claim(t, e, r, n, s, i = !1) {
      return d
        .post(`${this.url}/claimVirtua`, {
          utxos: t,
          changeAddress: e,
          unit: r,
          assetName: n,
          wallet: s,
          testEnv: i,
        })
        .then((a) => a.data)
        .catch((a) => u(a));
    }
    submitTx(t, e) {
      return d
        .post(`${this.url}/submitTx`, {
          transaction: t,
          signature: e,
          projectId: this.projectId,
        })
        .then((r) => r.data)
        .catch((r) => u(r));
    }
    verifyTx(t) {
      return d
        .post(`${this.url}/verifyClaimTx`, { transaction: t })
        .then((e) => e.data)
        .catch((e) => u(e));
    }
    parseAddress(t) {
      return d
        .post(`${this.url}/parseAddress`, { changeAddress: t })
        .then((e) => e.data)
        .catch((e) => u(e));
    }
  },
  c = new p();
var m = ((s) => (
  (s.Nami = "nami"),
  (s.Eternl = "eternl"),
  (s.Flint = "flint"),
  (s.Gero = "gerowallet"),
  (s.Typhon = "typhoncip30"),
  s
))(m || {});
var h = class {
    constructor() {
      this.initiatedTime = new Date().getTime();
      this.currentWallet = void 0;
      this.currentWalletId = void 0;
    }
    getWalletId(t) {
      let e = this.getExtensionsNames(),
        r = this.getExtensionsIds();
      if (e.includes(t)) return m[t];
      if (r.includes(t)) return t;
      throw new Error(
        `Invalid wallet provided, should be one of ${r.join(", ")}`
      );
    }
    pause(t) {
      return new Promise((e) => setTimeout(e, t));
    }
    getExtensionsNames() {
      return Object.keys(m);
    }
    getExtensionsIds() {
      return Object.values(m).filter((t) => Number.isNaN(Number(t)));
    }
    getExtension(t) {
      let e = this.getWalletId(t),
        r = null;
      return window.cardano && window.cardano[e] && (r = window.cardano[e]), r;
    }
    async getAvailableExtensions() {
      let t = this.getExtensionsIds(),
        e = [],
        r = new Date().getTime() - this.initiatedTime;
      if ((r < 500 && (await this.pause(Math.max(500 - r, 0))), window.cardano))
        for (let n of t) window.cardano[n] && e.push(n);
      return e;
    }
    async isConnected(t) {
      let e = this.getExtension(t),
        r = !1;
      if (e)
        try {
          r = await e.isEnabled();
        } catch {
          r = !1;
        }
      return r;
    }
    async connect(t) {
      let e = this.getExtension(t),
        r = !1;
      if (((this.currentWalletId = void 0), e))
        try {
          (this.currentWallet = await e.enable()),
            (r = !0),
            (this.currentWalletId = t);
        } catch {
          r = !1;
        }
      return r;
    }
    async getInventory(t) {
      let e = [];
      if (!this.currentWallet)
        throw new Error("Connect a wallet to get the inventory");
      try {
        e = await this.currentWallet.getUtxos();
      } catch {
        throw new Error("Could not get utxos from current wallet");
      }
      let r = await c.getInventory(e, t);
      if (!r.success) throw new Error(r.error);
      return r.assets;
    }
    async claim(t, e, r) {
      let n = [],
        s;
      if (!this.currentWallet) throw new Error("Connect a wallet to claim");
      try {
        n = await this.currentWallet.getUtxos();
      } catch {
        throw new Error("Could not get utxos from current wallet");
      }
      let i = await this.currentWallet.getChangeAddress(),
        a = await c.claim(n, i, t, e, this.currentWalletId, r);
      if (!a.success) throw new Error(a.error);
      try {
        s = await this.currentWallet.signTx(a.transaction, !0);
      } catch {
        throw new Error(
          "User declined to sign the transaction or signature failed"
        );
      }
      let g = await c.submitTx(a.transaction, s);
      if (!g.success) throw new Error(g.error);
      try {
        g.submittedTx && (await this.currentWallet.submitTx(g.submittedTx));
      } catch {}
      return g.transactionHash;
    }
    async claimCribs(t, e, r, n, s, i) {
      let a = await c.claimCribs(r, n, t, e, s, i);
      if (!a.success) throw new Error(a.error);
      return a.transaction;
    }
    async mintLand(t, e, r, n, s) {
      let i = await c.mintLand(e, r, t, n, s);
      if (!i.success) throw new Error(i.error);
      return i.transaction;
    }
    async verifyTx(t) {
      let e = await c.verifyTx(t);
      if (!e.success) throw new Error(e.error);
      return e.status;
    }
    async signTx(t) {
      if (!this.currentWallet) throw new Error("Connect a wallet to sign");
      let e;
      try {
        e = await this.currentWallet.signTx(t, !0);
      } catch {
        throw new Error(
          "User declined to sign the transaction or signature failed"
        );
      }
      return e;
    }
    async submitTx(t, e) {
      let r = await c.submitTx(t, e);
      if (!r.success) throw new Error(r.error);
      if (this.currentWallet)
        try {
          r.submittedTx && (await this.currentWallet.submitTx(r.submittedTx));
        } catch {}
      return r.transactionHash;
    }
    async getWalletData() {
      let t = [];
      if (!this.currentWallet) throw new Error("Connect a wallet to get data");
      try {
        t = await this.currentWallet.getUtxos();
      } catch {
        throw new Error("Could not get utxos from current wallet");
      }
      let e = await this.currentWallet.getChangeAddress();
      return { utxos: t, changeAddress: e, walletId: this.currentWalletId };
    }
    async getConnectedWalletAddress() {
      if (!this.currentWallet)
        throw new Error("Connect a wallet to get the address");
      let t = await this.currentWallet.getChangeAddress(),
        e = await c.parseAddress(t);
      if (!e.success) throw new Error(e.error);
      return e.address;
    }
  },
  o = new h();
var w = class {
    setApiKey(t) {
      c.setApiKey(t);
    }
    getExtensionsNames() {
      return o.getExtensionsNames();
    }
    getExtensionsIds() {
      return o.getExtensionsIds();
    }
    getAvailableExtensions() {
      return o.getAvailableExtensions();
    }
    isConnected(t) {
      return o.isConnected(t);
    }
    connect(t) {
      return o.connect(t);
    }
    getConnectedWalletAddress() {
      return o.getConnectedWalletAddress();
    }
    getInventory(t) {
      return o.getInventory(t);
    }
    claimLand(t, e, r) {
      return o.claim(t, e, r);
    }
    claimCribs(t, e, r, n, s, i) {
      return o.claimCribs(t, e, r, n, s, i);
    }
    mintLand(t, e, r, n, s) {
      return o.mintLand(t, e, r, n, s);
    }
    claim(t, e, r) {
      return o.claim(t, e, r);
    }
    getTxStatus(t) {
      return o.verifyTx(t);
    }
    signTx(t) {
      return o.signTx(t);
    }
    submitTx(t, e) {
      return o.submitTx(t, e);
    }
    getWalletData() {
      return o.getWalletData();
    }
  },
  U = new w();
export { U as default };
